import type { CustomFieldConfig, CustomFieldOption, CustomFieldType } from '../types';

/** O mínimo de um campo adicional para mostrar ou editar o valor. */
export interface FieldShape {
  name: string;
  type: CustomFieldType;
  options: CustomFieldOption[];
  config: CustomFieldConfig;
  helpText?: string | null;
}

/** Valor de múltipla escolha: array JSON de ids de opção. */
export const parseMulti = (value: string): string[] => {
  try {
    const parsed: unknown = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
};

/** Como o valor aparece em texto (ficha, tabela): rótulo da opção, Sim/Não, estrelas. */
export const displayFieldValue = (field: FieldShape, value: string | null): string => {
  if (value === null || value === '') return '—';
  switch (field.type) {
    case 'SELECT':
      return field.options.find((option) => option.id === value)?.label ?? value;
    case 'MULTI_SELECT':
      return parseMulti(value)
        .map((id) => field.options.find((option) => option.id === id)?.label ?? id)
        .join(', ');
    case 'BOOLEAN':
      return value === 'true' ? 'Sim' : 'Não';
    case 'RATING':
      return '★'.repeat(Number(value) || 0);
    default:
      return value;
  }
};
